import { render } from "./DashboardRateGold.vue?vue&type=template&id=4eb65096"
import script from "./DashboardRateGold.vue?vue&type=script&lang=js"
export * from "./DashboardRateGold.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/karman/karman_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__